import { Icon as BaseIcon, IIconProps } from "@fluentui/react";
import React from "react";

export interface IconProps extends Pick<IIconProps, "iconName"> {
    disabled?: boolean;
    color?: string;
    size?: number;
    display?: string;
    alignItems?: string;
    padding?: string;
}

export const Icon: React.FunctionComponent<IconProps> = (props: IconProps) => {
    return (
        <BaseIcon
            iconName={props.iconName}
            styles={{
                root: {
                    color: props.disabled ? "#a19f9d" : props.color,
                    fontSize: props.size,
                    display: props.display,
                    alignItems: props.alignItems,
                    padding: props.padding
                }
            }}
        />
    );
};
